import Vue from "vue";
const ctx = "@@marquee";
var currentY = null;
var getComputedStyle = Vue.prototype.$isServer
  ? {}
  : document.defaultView.getComputedStyle;

var getComputedTranslateY = function(obj) {
  if (!window.getComputedStyle) return;
  var style = getComputedStyle(obj),
    transform = style.transform || style.webkitTransform || style.mozTransform;
  if (!transform) {
    return;
  }
  var mat = transform.match(/^matrix3d\((.+)\)$/);
  if (mat) return parseFloat(mat[1].split(", ")[13]);
  mat = transform.match(/^matrix\((.+)\)$/);
  return mat ? parseFloat(mat[1].split(", ")[5]) : 0;
};
var autoScroll = function(obj, step) {
  var ul = obj.querySelector("ul");
  var marginTop = parseFloat(getComputedTranslateY(ul));
  marginTop -= 1;
  ul.style.webkitTransform
    ? (ul.style.webkitTransform = "translate3d(0," + marginTop + "px" + ",0)")
    : (ul.style.transform = "translate3d(0," + marginTop + "px" + ",0)");
  var s = Math.abs(parseInt(getComputedTranslateY(ul)));
  if (s >= step) {
    var li = ul.querySelectorAll("li")[0];
    ul.appendChild(li);
    ul.style.webkitTransform
      ? (ul.style.webkitTransform = "translate3d(0,0,0)")
      : (ul.style.transform = "translate3d(0,0,0)");
  }
};
var doBind = function() {
  var directive = this;
  var element = directive.el;
  var ul = element.querySelector("ul");
  var li = ul.querySelectorAll("li")[0];
  var sh = Math.abs(parseInt(getComputedStyle(li).height)),
    clearTimer = element.getAttribute("clearTimer"),
    speed = element.getAttribute("speed");
  var ul = element.querySelector("ul");
  if (directive.timer) {
    clearInterval(directive.timer);
  }
  if (clearTimer) {
    clearInterval(directive.timer);
  }
  directive.timer = setInterval(() => {
    if (
      parseFloat(getComputedStyle(ul).height) <=
      parseFloat(getComputedStyle(element).height)
    ) {
      clearInterval(directive.timer);
    } else {
      autoScroll(element, sh);
    }
  }, speed);
  element.ontouchstart = function(event) {
    event.preventDefault();
    clearInterval(directive.timer);
  };
  element.ontouchend = function(event) {
    if (directive.timer) {
      clearInterval(directive.timer);
    }
    directive.timer = setInterval(() => {
      if (
        parseFloat(getComputedStyle(ul).height) <=
        parseFloat(getComputedStyle(element).height)
      ) {
        clearInterval(directive.timer);
      } else {
        autoScroll(element, sh);
      }
    }, speed);
  };
};

export default {
  bind(el, binding, vnode) {
    el[ctx] = {
      el,
      vm: vnode.context,
      expression: binding.value
    };
    var cb = function() {
      el[ctx].vm.$nextTick(function() {
        doBind.call(el[ctx]);
      });
    };
    if (el[ctx].vm._isMounted) {
      if (el[ctx].timer) {
        clearInterval(el[ctx].timer);
      }
      cb();
    }
    el[ctx].vm.$on("hook:mounted", () => {
      if (el[ctx].timer) {
        clearInterval(el[ctx].timer);
      }
      cb();
    });
    el[ctx].vm.$on("hook:activated", () => {
      if (el[ctx].timer) {
        clearInterval(el[ctx].timer);
      }
      cb();
    });
    el[ctx].vm.$on("hook:deactivated", () => {
      if (el[ctx].timer) {
        clearInterval(el[ctx].timer);
      }
    });
    el[ctx].vm.$on("hook:destroyed", () => {
      if (el[ctx].timer) {
        clearInterval(el[ctx].timer);
      }
    });
  }
};
